module.exports = __webpack_public_path__ + "assets/quoteLeft.8dceb128d7d45e8ed1eb581a2fa7b13b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/level/quoteLeft.svg
// module id = 863
// module chunks = 0